"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccumulationRuleset = getAccumulationRuleset;
const federal_1 = require("./federal");
// Resolves the federal accumulation rules that apply to a given facility
// context. State and episodic overlays widen this in a later project; for
// now every match is FEDERAL-sourced.
function getAccumulationRuleset(ctx) {
    return federal_1.FEDERAL_RULES.filter((rule) => {
        const areaTypeMatches = rule.areaType === ctx.areaType;
        const generatorStatusMatches = rule.generatorStatus === "ANY" ||
            (ctx.generatorStatus !== null && rule.generatorStatus === ctx.generatorStatus);
        const conditionMatches = rule.condition ? rule.condition(ctx) : true;
        return areaTypeMatches && generatorStatusMatches && conditionMatches;
    }).map((rule) => ({ rule, source: "FEDERAL" }));
}
//# sourceMappingURL=getAccumulationRuleset.js.map